import React from "react";
import {
  Header,
  Footer,
  SubscribePlan,
  BuyMagazine,
  EmailVerified,
  LinkExpired,
  AuthorDetail,
  Dashboard,
  MagazineList,
  ArticleList,
  MagazineDetail,
  BookMarks,
  Plans,
  MyAccount,
  PrivacyPolicy,
  Terms,
  Layout,
  ContactUs,
  FeedBack,
  CategoryDetailsList,
  CategoryList,
  ArticleDetails,
  TopArticles,
  FeaturedArticles,
  FreeArticles,
  AnswerQuiz,
  PDFReader,
} from "../../pages";
import { MainRoute } from "../../routes";

import { BreadCrumb, BreadCrumbList } from "../../components";
import { SearchArticles } from "../Search";
// ===========================|| AUTH ROUTING ||=========================== //

const MainRoutes = {
  path: "/",
  element: "",
  // <Layout /> ,
  children: [
    {
      path: "/home",
      element: (
        <>
          <Header />
          <Dashboard />
          <Footer />
        </>
      ),
    },
    {
      path: "/magazines",
      element: (
        <>
          <MainRoute>
            <Header />
            <MagazineList />
            <Footer />
          </MainRoute>
        </>
      ),
    },
    {
      path: "/articles",
      element: (
        <>
          <MainRoute>
            <Header />
            <ArticleList />
            <Footer />
          </MainRoute>
        </>
      ),
    },
    {
      path: "/top-articles",
      element: (
        <>
          <MainRoute>
            <Header />
            <TopArticles />
            <Footer />
          </MainRoute>
        </>
      ),
    },
    {
      path: "/featured-articles",
      element: (
        <>
          <MainRoute>
            <Header />
            <FeaturedArticles />
            <Footer />
          </MainRoute>
        </>
      ),
    },
    {
      path: "/free-articles",
      element: (
        <>
          <MainRoute>
            <Header />
            <FreeArticles />
            <Footer />
          </MainRoute>
        </>
      ),
    },
    {
      path: "/magazine-detail/:magID",
      element: (
        <>
          <MainRoute>
            <Header />
            <MagazineDetail />
          </MainRoute>
        </>
      ),
    },

    {
      path: "/answer-quiz/:id",
      element: (
        <>
          <MainRoute>
            <AnswerQuiz />
          </MainRoute>
        </>
      ),
    },

    {
      path: "/author-detail/:authorID",
      element: (
        <>
          <MainRoute>
            <Header />
            <AuthorDetail />
          </MainRoute>
        </>
      ),
    },
    {
      path: "/bookmarks",
      element: (
        <>
          <MainRoute>
            <Header />
            <BookMarks />
            <Footer />
          </MainRoute>
        </>
      ),
    },
    {
      path: "/plans",
      element: (
        <>
          <Header />
          <Plans />
          <Footer />
        </>
      ),
    },
    {
      path: "/account",
      element: (
        <>
          <MainRoute>
            <Header />
            <MyAccount />
            <Footer />
          </MainRoute>
        </>
      ),
    },
    {
      path: "/privacy-policy",
      element: (
        <>
          <Header />
          <PrivacyPolicy />
          <Footer />
        </>
      ),
    },
    {
      path: "/terms",
      element: (
        <>
          <Header />
          <Terms />
          <Footer />
        </>
      ),
    },
    {
      path: "/contact-us",
      element: (
        <>
          <Header />
          <ContactUs />
          <Footer />
        </>
      ),
    },
    {
      path: "/feedback",
      element: (
        <>
          <MainRoute>
            <Header />
            <FeedBack />
            <Footer />
          </MainRoute>
        </>
      ),
    },
    {
      path: "/category-details/:catID",
      element: (
        <>
          <MainRoute>
            <Header />
            <CategoryDetailsList />
            {/* <Footer /> */}
          </MainRoute>
        </>
      ),
    },
    {
      path: "/category-List",
      element: (
        <>
          <MainRoute>
            <Header />
            <CategoryList />
            <Footer />
          </MainRoute>
        </>
      ),
    },
    {
      path: "/article-details/:artID",
      element: (
        <>
          <MainRoute>
            <Header />
            <ArticleDetails />
            {/* <Footer /> */}
          </MainRoute>
        </>
      ),
    },
    {
      path: "/read-magazine/:magID",
      element: (
        <>
          <MainRoute>
            <Header />
            <PDFReader />
          </MainRoute>
        </>
      ),
    },
    {
      path: "/search-articles",
      element: (
        <>
          <MainRoute>
            <Header />
            <SearchArticles />
            <Footer />
          </MainRoute>
        </>
      ),
    },
  ],
};

export default MainRoutes;
